/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TableStatus from './TableStatus';
import TaskInResultResponse from './TaskInResultResponse';

/**
 * The GetTablePreProcessingResponse model module.
 * @module model/GetTablePreProcessingResponse
 * @version 2.8.0
 */
class GetTablePreProcessingResponse {
    /**
     * Constructs a new <code>GetTablePreProcessingResponse</code>.
     * @alias module:model/GetTablePreProcessingResponse
     * @param id {String} 
     * @param name {String} 
     * @param path {String} 
     * @param status {module:model/TableStatus} 
     * @param creationDate {String} 
     * @param lastModificationDate {String} 
     * @param preprocessingTask {module:model/TaskInResultResponse} 
     */
    constructor(id, name, path, status, creationDate, lastModificationDate, preprocessingTask) { 
        
        GetTablePreProcessingResponse.initialize(this, id, name, path, status, creationDate, lastModificationDate, preprocessingTask);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name, path, status, creationDate, lastModificationDate, preprocessingTask) { 
        obj['id'] = id;
        obj['name'] = name;
        obj['path'] = path;
        obj['status'] = status;
        obj['creationDate'] = creationDate;
        obj['lastModificationDate'] = lastModificationDate;
        obj['preprocessingTask'] = preprocessingTask;
    }

    /**
     * Constructs a <code>GetTablePreProcessingResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetTablePreProcessingResponse} obj Optional instance to populate.
     * @return {module:model/GetTablePreProcessingResponse} The populated <code>GetTablePreProcessingResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetTablePreProcessingResponse();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('path')) {
                obj['path'] = ApiClient.convertToType(data['path'], 'String');
            }
            if (data.hasOwnProperty('projectCollection')) {
                obj['projectCollection'] = ApiClient.convertToType(data['projectCollection'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = TableStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'String');
            }
            if (data.hasOwnProperty('lastModificationDate')) {
                obj['lastModificationDate'] = ApiClient.convertToType(data['lastModificationDate'], 'String');
            }
            if (data.hasOwnProperty('preprocessingTask')) {
                obj['preprocessingTask'] = TaskInResultResponse.constructFromObject(data['preprocessingTask']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} id
 */
GetTablePreProcessingResponse.prototype['id'] = undefined;

/**
 * @member {String} name
 */
GetTablePreProcessingResponse.prototype['name'] = undefined;

/**
 * @member {String} path
 */
GetTablePreProcessingResponse.prototype['path'] = undefined;

/**
 * @member {String} projectCollection
 */
GetTablePreProcessingResponse.prototype['projectCollection'] = undefined;

/**
 * @member {module:model/TableStatus} status
 */
GetTablePreProcessingResponse.prototype['status'] = undefined;

/**
 * @member {String} creationDate
 */
GetTablePreProcessingResponse.prototype['creationDate'] = undefined;

/**
 * @member {String} lastModificationDate
 */
GetTablePreProcessingResponse.prototype['lastModificationDate'] = undefined;

/**
 * @member {module:model/TaskInResultResponse} preprocessingTask
 */
GetTablePreProcessingResponse.prototype['preprocessingTask'] = undefined;






export default GetTablePreProcessingResponse;

